// src/components/Showcase.jsx
import React from 'react';

export default function Showcase() {
  return (
    <section className="py-24 px-6 text-white bg-gradient-to-b from-[#0f172a] to-[#1e293b]">
      <div className="max-w-5xl mx-auto text-center mb-16">
        <h2 className="text-4xl font-bold mb-4">How You Can Use InvokeApi</h2>
        <p className="text-lg text-gray-300">
          Unlock powerful use cases across automation, AI agents, and developer tools — all through simple hosted APIs.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto text-left">
        <div className="bg-white/5 border border-white/10 p-6 rounded-xl shadow hover:shadow-md transition">
          <h3 className="text-xl font-semibold mb-2">Supercharge Your AI Agents</h3>
          <p className="text-gray-300 text-sm">
            Feed invoices, summaries, or structured responses to GPT agents using hosted, schema-friendly endpoints.
          </p>
        </div>

        <div className="bg-white/5 border border-white/10 p-6 rounded-xl shadow hover:shadow-md transition">
          <h3 className="text-xl font-semibold mb-2">Automate Workflows with Zapier or n8n</h3>
          <p className="text-gray-300 text-sm">
            Use InvokeApi as a building block in automation platforms to generate invoices or clean text without code.
          </p>
        </div>

        <div className="bg-white/5 border border-white/10 p-6 rounded-xl shadow hover:shadow-md transition">
          <h3 className="text-xl font-semibold mb-2">Build Internal Tools in Minutes</h3>
          <p className="text-gray-300 text-sm">
            Power admin dashboards, PDF exports, and summarization tools with reliable hosted APIs.
          </p>
        </div>
      </div>
    </section>
  );
}
